import {envIsDev} from '../../../../config';
import {
  recordRumAction,
  recordRumError,
} from '../../../../util/datadog/datadogRum';
import {type BucketedLine} from '../../types';
import {
  type GroupedBackendLinesQueryRuns,
  type GroupedBucketedQueryRuns,
  type GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

// it's very hard to do segmentation in datadog, so we need an enum to group on
export function getLineGroup(numLines: number) {
  if (!numLines) {
    return 'unknown';
  }
  if (numLines < 21) {
    return '1-20';
  } else if (numLines < 41) {
    return '21-40';
  } else if (numLines < 61) {
    return '41-60';
  } else if (numLines < 81) {
    return '61-80';
  } else if (numLines < 101) {
    return '81-100';
  } else if (numLines < 121) {
    return '101-120';
  } else if (numLines < 141) {
    return '121-140';
  } else if (numLines < 161) {
    return '141-160';
  } else if (numLines < 181) {
    return '161-180';
  } else if (numLines < 201) {
    return '181-200';
  } else if (numLines < 221) {
    return '201-220';
  } else if (numLines < 241) {
    return '221-240';
  } else if (numLines < 261) {
    return '241-260';
  } else {
    return '261+';
  }
}

const debugBucketedDataEvents = false;
export function trackedBucketedDataEvent(
  eventName: string,
  context: Record<string, any>
) {
  if (envIsDev && debugBucketedDataEvents) {
    console.log(`Bucketed_data_event: ${eventName}`, context);
  } else {
    recordRumAction(`Bucketed_data_event: ${eventName}`, context);
  }
}

export function isAggregatedRuns(
  runs:
    | GroupedBucketedQueryRuns
    | GroupedBackendLinesQueryRuns
    | null
    | undefined
): runs is GroupedBucketedQueryRunWithGroupedRunConnection {
  return runs?.__typename === 'GroupedRunConnection';
}

export function profileRenderTimeSaved(
  runsById: Record<string, BucketedLine>,
  type: 'backend' | 'grouped'
) {
  try {
    const numPoints = Object.values(runsById).reduce((acc, run) => {
      const hPoints = (run.historyLines ?? []).reduce((ac, line) => {
        return ac + line.historyLine.length;
      }, 0);
      return acc + hPoints;
    }, 0);
    trackedBucketedDataEvent('Backend_line_render_saved', {
      numRuns: Object.keys(runsById).length,
      numPoints,
      type,
    });
  } catch (e) {
    recordRumError(new Error('backend lines profiling error'), {
      reason: 'Error profiling backend lines',
      error: e,
    });
    return;
  }
}

export function extractDeltasInfo<
  T extends {deltas?: {delta?: any[]; order?: any[]} | null},
>(
  runs: T | null | undefined
): {
  deltas: any[];
  order: any[];
} {
  return {
    deltas: runs?.deltas?.delta ?? [],
    order: runs?.deltas?.order ?? [],
  };
}
